const normalizeId = (value) => (
  value === undefined || value === null ? '' : String(value).trim()
);

const uniqueIds = (values) => [...new Set(
  (Array.isArray(values) ? values : []).map(normalizeId).filter(Boolean)
)];

export const buildRateCodeNameMap = (rateCodes) => (
  (Array.isArray(rateCodes) ? rateCodes : []).reduce((names, rateCode) => {
    const id = normalizeId(rateCode?._id);
    if (id) {
      names[id] = normalizeId(rateCode?.rate_code) || id;
    }
    return names;
  }, {})
);

export const buildActiveRateCodeDetails = (mappingRecords, rateCodes) => {
  const names = buildRateCodeNameMap(rateCodes);
  const mapping = Array.isArray(mappingRecords) ? mappingRecords[0] : null;
  const activeIds = uniqueIds(mapping?.active_rate_codes)
    .filter((id) => Boolean(names[id]));

  return {
    names,
    activeIds,
    details: activeIds.map((id) => ({ rate_id: id, name: names[id] })),
  };
};

export const describeRateRuleAvailability = ({
  companyName,
  rateCodeNames,
  activeRateCodeIds,
  baseRateCodeId,
  availableRateCodeIds,
}) => {
  const accountLabel = normalizeId(companyName) || 'This account';
  const configuredCount = Object.keys(rateCodeNames || {}).length;
  const activeIds = uniqueIds(activeRateCodeIds);
  const availableIds = uniqueIds(availableRateCodeIds);
  const baseId = normalizeId(baseRateCodeId);
  const baseLabel = normalizeId(rateCodeNames?.[baseId]) || baseId;

  if (availableIds.length > 0) {
    return { canAdd: true, title: '', message: '' };
  }

  if (activeIds.length === 0) {
    return {
      canAdd: false,
      title: 'No active rate codes available',
      message: `${accountLabel} has ${configuredCount} configured rate code${configuredCount === 1 ? '' : 's'}, but none are active. Open Account Rate Codes, enable at least two rate codes for a reservation source, save, and then return here.`,
    };
  }

  if (baseId && activeIds.length === 1) {
    return {
      canAdd: false,
      title: 'Another active rate code is required',
      message: `${accountLabel} has only one active rate code${baseLabel ? ` (${baseLabel})` : ''}, and it is already the base rate. Open Account Rate Codes, enable another configured rate code for a reservation source, save, and then return here.`,
    };
  }

  return {
    canAdd: false,
    title: 'No unused active rate codes remain',
    message: `All ${activeIds.length} active rate codes for ${accountLabel} are already assigned as the base rate or have an existing rule. Edit an existing rule, or activate another configured rate code in Account Rate Codes.`,
  };
};
